import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import HowItWorks from './pages/HowItWorks';
import Checklists from './pages/Checklists';
import EvidenceVault from './pages/EvidenceVault';
import PolicyLibrary from './pages/PolicyLibrary';
import Settings from './pages/Settings';
import FAQ from './pages/FAQ';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="how-it-works" element={<HowItWorks />} />
          <Route path="checklists" element={<Checklists />} />
          <Route path="vault" element={<EvidenceVault />} />
          <Route path="policies" element={<PolicyLibrary />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;